(function(angular){
	"use strict";
	// This provides a back-compat mapping for old bootstrap modal defs using new bootstrap modal defs.
	var module = angular.module("ui.bootstrap");
	module.provider("$tooltip", function(){
		// This is back-compating the $modal and $modalInstance API by mapping it to the uib version as much as possible.
		this.$get = ["$uibTooltip", "$templateCache", 
			function($uibTooltip, $templateCache){
			// Backmap the template too.
			$templateCache.put("template/tooltip/tooltip-popup.html", $templateCache.get("uib/template/tooltip/tooltip-popup.html"));
			return $uibTooltip;
		}];
	});
	module.provider("$position", function(){
		// This is back-compating the $modal and $modalInstance API by mapping it to the uib version as much as possible.
		this.$get = ["$uibPosition", 
			function($uibPosition){
			return $uibPosition;
		}];
	});
})(window.angular);
